export default "__VITE_ASSET__CH274CA7__"